// extracted by mini-css-extract-plugin
module.exports = {"container":"noteForm_container__2ZoZa","fields":"noteForm_fields__36vkO","buttons":"noteForm_buttons__2aDMF"};